<template>
  <v-card>
    <v-toolbar color="transparent" flat dense card v-if="enableHeader">
      <v-toolbar-title>
        <h4 class="font-weight-regular">{{ title }}</h4>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <slot name="widget-header-action"></slot>
    </v-toolbar>
    <v-divider v-if="enableHeader"></v-divider>
    <v-card-text class="pa-0" :class="contentBg">
      <slot name="widget-content"></slot>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "v-widget",
  props: {
    title: {
      type: String
    },
    enableHeader: {
      type: Boolean,
      default: true
    },
    contentBg: {
      type: String,
      default: ""
    }
  },

  data() {
    return {};
  },
  computed: {}
};
</script>
